module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/favicon_c3e0a2b.ico";